(() => {
    const $parentSubMenuWraps = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item-has-children');
    const $subMenuWraps = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item-has-children, .site-menu-bar .menu-item-has-children:not(.menu-item--layout-sub-menu-columns) .menu-item-has-children');

    const enableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        if ($subMenuWrap.classList.contains('menu-item--active')) return;

        $subMenuWrap.classList.add('menu-item--active');
        $subMenuToggle.setAttribute('aria-expanded', 'true');
    };

    const disableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        $subMenuWrap.classList.remove('menu-item--active');
        $subMenuToggle.setAttribute('aria-expanded', 'false');
    };

    const initSubMenuDropdowns = () => {
        $parentSubMenuWraps.forEach($subMenuWrap => {
            if (!$subMenuWrap) return;

            const $subMenuToggle = $subMenuWrap.querySelector('a');

            if (!$subMenuToggle) return;

            $subMenuToggle.addEventListener('click', e => {
                e.preventDefault();

                    enableSubMenu($subMenuWrap, $subMenuToggle);

                    resizeSubMenus();
            });

            $subMenuWrap.addEventListener('mouseover', e => {
                enableSubMenu($subMenuWrap, $subMenuToggle);
            });

            $subMenuWrap.addEventListener('mouseleave', e => {
                disableSubMenu($subMenuWrap, $subMenuToggle);
            });
        });

        $parentSubMenuWraps.forEach($parentSubMenuWrap => {
            const $subMenuToggle = $parentSubMenuWrap.querySelector('a');

            window.addEventListener('click', e => {
                if ($parentSubMenuWrap.contains(e.target)) return;

                disableSubMenu($parentSubMenuWrap, $subMenuToggle);

                const $activeChildSubMenus = $parentSubMenuWrap.querySelectorAll('.menu-item--active');

                $activeChildSubMenus?.forEach($activeChildSubMenu => {
                    disableSubMenu($activeChildSubMenu, $activeChildSubMenu.querySelector('a'));
                });

                setTimeout(() => {
                    resizeSubMenus();
                }, 300);
            });
        });
    };

    const subMenuOffset = () => {
        $subMenuWraps.forEach($subMenuWrap => {
            if (!$subMenuWrap) return;

            const $subMenuDropdowns = $subMenuWrap.querySelectorAll('.sub-menu-dropdown');

            if (!$subMenuDropdowns) return;

            $subMenuDropdowns.forEach($subMenuDropdown => {
                $subMenuDropdown.style.marginLeft = '';

                const leftOffset = $subMenuDropdown.getBoundingClientRect().left;
                const rightOffset = leftOffset + $subMenuDropdown.clientWidth - document.body.clientWidth;

                if (rightOffset > 0) {
                    $subMenuDropdown.style.marginLeft = `${-rightOffset}px`;
                }

                if (leftOffset < 0) {
                    $subMenuDropdown.style.marginLeft = `${-leftOffset}px`;
                }
            });
        });
    };

    const resizeSubMenu = $subMenu => {
        if (!$subMenu) return;

        const $subMenuDropdownMenu = $subMenu.querySelector('.sub-menu-dropdown__menu');

        let width = $subMenuDropdownMenu.clientWidth;
        let height = $subMenuDropdownMenu.clientHeight;
    };

    const resizeSubMenus = () => {
        if (!$parentSubMenuWraps) return;

        $parentSubMenuWraps.forEach($parentSubMenuWrap => {
            resizeSubMenu($parentSubMenuWrap);
        });
    };

    window.addEventListener('resize', () => {
        subMenuOffset();
        resizeSubMenus();
    });

    initSubMenuDropdowns();
    subMenuOffset();
    resizeSubMenus();
})();
